import { render, staticRenderFns } from "./VizletHeader.vue?vue&type=template&id=2442c39a&scoped=true&"
import script from "./VizletHeader.vue?vue&type=script&lang=js&"
export * from "./VizletHeader.vue?vue&type=script&lang=js&"
import style0 from "./VizletHeader.vue?vue&type=style&index=0&id=2442c39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442c39a",
  null
  
)

export default component.exports